import {DragOverlay} from '@dnd-kit/core';

import {useLayoutEffect} from 'react';

import {isNotNil, not} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {LAYOUT_CONTENT_ID, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {useActiveId} from '../hooks/useActiveId';
import {useEvents} from '../hooks/useEvents';
import {isAllDayHeaderEvent} from '../utils/isAllDayHeaderEvent';
import {AllDayEventItem} from './AllDayEventItem';
import {EventItem} from './EventItem';

export function BigCalendarDragOverlay(props: RequiredTestIdProps) {
  const activeId = useActiveId();
  const optimisticEvents = useEvents();

  useLayoutEffect(() => {
    const layoutContent = document.getElementById(LAYOUT_CONTENT_ID);

    if (activeId && document.body.style.overflow !== 'hidden') {
      document.body.style.overflow = 'hidden';
    }
    if (isNilOrEmpty(activeId) && document.body.style.overflow === 'hidden') {
      document.body.style.overflow = 'auto';
    }

    if (activeId && layoutContent && layoutContent?.style.overflow !== 'hidden') {
      layoutContent.style.overflow = 'hidden';
    }
    if (isNilOrEmpty(activeId) && layoutContent && layoutContent?.style.overflow === 'hidden') {
      layoutContent.style.overflow = 'auto';
    }
  }, [activeId]);

  const activeOptimisticEvent = activeId ? optimisticEvents.find((e) => e.id === activeId) : null;

  const draggedEventDuration = isNotNil(activeOptimisticEvent)
    ? activeOptimisticEvent.end.getTime() - activeOptimisticEvent.start.getTime() // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
    : null;

  return (
    <DragOverlay data-testid={suffixTestId('bigCalendarDragOverlay', props)}>
      {/* eslint-disable-next-line eag/prefer-show -- Pre-existing violation */}
      {isNotNil(activeOptimisticEvent) &&
      isNotNil(draggedEventDuration) &&
      not(isAllDayHeaderEvent(activeOptimisticEvent)) ? (
        <EventItem
          key={activeOptimisticEvent.id}
          event={activeOptimisticEvent}
          data-testid={suffixTestId('bigCalendarDragOverlayEventItem', props)}
        />
      ) : null}
      {/* eslint-disable-next-line eag/prefer-show -- Pre-existing violation */}
      {isNotNil(activeOptimisticEvent) && isAllDayHeaderEvent(activeOptimisticEvent) ? (
        <AllDayEventItem
          event={activeOptimisticEvent}
          data-testid={suffixTestId('bigCalendarDragOverlayAllDayEventItem', props)}
        />
      ) : null}
    </DragOverlay>
  );
}
